import { defineNuxtPlugin } from '#imports'
import { useLogger } from '~/composables/useLogger'

function toError(value: unknown): Error {
  return value instanceof Error ? value : new Error(String(value))
}

// Universal, not .client.ts, since Vue's errorHandler also fires during SSR. A chunk-load
// failure (NUXT_E1005) bypasses this and reports itself via the app root error page instead.
export default defineNuxtPlugin((nuxtApp) => {
  const logger = useLogger('ClientLogCapture')

  nuxtApp.vueApp.config.errorHandler = (error) => {
    logger.error('uncaught_error', toError(error))
  }

  if (!import.meta.client) return

  window.addEventListener('error', (event) => {
    logger.error('window_error', toError(event.error ?? event.message))
  })

  window.addEventListener('unhandledrejection', (event) => {
    logger.error('unhandled_rejection', toError(event.reason))
  })
})
